import React, { useEffect, useRef, useState } from 'react'
import { Services } from '@/services/services';
// import { ServicemanEditMachineForm, ServicemanInsertMachineForm, MachineFormData } from '@/components/forms/machines/Machine';
import { CurrentSession, SessionService } from '@/services/repository/session';
import { LoggedInPageLayout } from '@/components/layout/LoggedInLayout';
import { addServerErrors, onSubmit } from '@/components/forms/common/FormBase';
import { useForm, UseFormReturn } from 'react-hook-form';
import { PageQuery, PageResponse, SearchTable, SearchTableParams, SearchTableRef } from '@/components/search/SearchTable';
import { formatDate } from '@/common/time';
import { isDesktopScreen, isLargeScreen, useResponsiveChange } from '@/common/device';
import { Doc } from '@/services/model/docs';
// import { SimpleUser } from '../users/Users';
import { MachinePopupDocBody } from '@/popups/docs/docs';
import { MachinePopupQRCodeBody } from '@/popups/qrcode/qrcode';
import { useNavigate } from 'react-router-dom';
import { useModal } from '@/components/modal/Modal';
import { CardHistoryBody } from './CardHistory';
import { MachineMapComponent } from '@/components/Map/MachineMap';
import { BackButton } from '@/components/layout/NavBar';

export interface SimpleUser {
  id: string
  email: string
  username: string
  createdAt: Date
  isRelated?: boolean
}

export interface SimpleMachine {
  id: string
  imei: string
  name: string
  createdAt: Date
  machineTypeId: string
}

export interface ServicemanInsertPopupProps {
  services: Services,
  session: CurrentSession,
  onClose: () => void
  onInsert?: (data: { id: string, qr: string }) => void
}

export interface ServicemanEditMachinesPopupProps {
  services: Services,
  session: CurrentSession,
  onClose: () => void
  machineId: string | undefined
}

const RelatedUsersPage = ({ services, session, machineId, onClose }: { services: Services, session: CurrentSession, machineId: string | undefined, onClose: () => void }) => {
  // const [edited, setEdited] = useState<string>()
  // const [inserted, setInserted] = useState<boolean>(false)
  const searchTableRef = useRef<SearchTableRef>(null)

  const tableParams: SearchTableParams<SimpleUser> = {
    fetch: (q: PageQuery): Promise<PageResponse<SimpleUser>> => {
      return services.session.fetchWithToken(`/api/serviceman/machines/byid/${machineId}/users/search?pageNumber=${q.pageNumber || ''}&pageSize=${q.pageSize || ''}&search=${q.search || ''}`).then((r) => {
        if (r.status === 200) {
          return r.json()
        }
        return Promise.reject()
      })
    },
    pageQuery: {
      pageNumber: 1,
      pageSize: 30,
      search: ""
    },
    toolbox: () => <></>,
    header: () => <>
      <div className='hcol'></div>
      <div className='hcol desktop-only'>{session.translates.for('elements.table.users.createdAt')}</div>
      <div className='hcol desktop-only'>{session.translates.for('elements.table.users.email')}</div>
      <div className='hcol'>{session.translates.for('elements.table.users.username')}</div>
    </>,
    row: (row, state, setState) => <>
      <div className='col icocol' onClick={() => {
        setState((state) => {
          if (state === undefined) {
            return
          }
          state.data = state.data?.map(item =>
            item.id === row.id ? { ...item, isRelated: undefined } : item
          )
          return { ...state }
        })

        services.session.fetchWithToken(`/api/serviceman/machines/byid/${machineId}/relations/users/${row.id}`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: row.id,
            related: !row.isRelated
          }),
        }).then((resp) => {
          setState((state) => {
            if (state === undefined) {
              return
            }
            state.data = state.data?.map(item =>
              item.id === row.id ? { ...item, isRelated: resp.ok ? !row.isRelated : row.isRelated } : item
            )
            return { ...state }
          })
        })

      }}>
        {row.isRelated === undefined ? <div className='spinner'></div> : row.isRelated ? <i className='svgfont-checkbox' /> : <i className='svgfont-checkbox-blank' />}
      </div>
      <div className='col desktop-only'>{formatDate(new Date(row.createdAt))}</div>
      <div className='col desktop-only'>{row.email}</div>
      <div className='col'>{row.username}</div>
    </>,
    translates: session.translates
  }

  return <SearchTable ref={searchTableRef} {...tableParams} />
}

export const ServicemanMachineMapPopup = ({ services, session, onClose, imei }: {
  services: Services,
  session: CurrentSession,
  onClose: () => void
  imei: string
}) => {
  return <MachineMapComponent services={services} session={session} imei={imei} />
}

export const ServicemanMachinesPage = ({ services, session }: { services: Services, session: CurrentSession }) => {
  // const [edited, setEdited] = useState<string>()
  // const [editUsers, setEditUsers] = useState<string>()
  // const [inserted, setInserted] = useState<boolean>(false)
  // const [docsType, setDocType] = useState<string | undefined>(undefined)
  // const [qrPopup, setQRPopup] = useState<string | undefined>(undefined)
  const searchTableRef = useRef<SearchTableRef>(null)
  const navigate = useNavigate()
  const { openModal } = useModal()

  useResponsiveChange()

  const tableParams: SearchTableParams<SimpleMachine> = {
    fetch: (q: PageQuery): Promise<PageResponse<SimpleMachine>> => {
      return services.session.fetchWithToken(`/api/serviceman/machines/search?pageNumber=${q.pageNumber || ''}&pageSize=${q.pageSize || ''}&search=${q.search || ''}`).then((r) => {
        if (r.status === 200) {
          return r.json()
        }
        return Promise.reject()
      })
    },
    pageQuery: {
      pageNumber: 1,
      pageSize: 30,
      search: ""
    },
    toolbox: () => <>
      {/* <div className='tool' onClick={() => openModal((props) => ServicemanInsertMachinesPopup({ ...props, services, session }))}><i className='svgfont-add' /></div> */}
    </>,
    header: () => <>
      {isDesktopScreen() && <div className='hcol '>{session.translates.for('elements.table.machines.createdAt')}</div>}
      {isDesktopScreen() && <div className='hcol'>{session.translates.for('elements.table.machines.imei')}</div>}
      {/* <div className='hcol'>{session.translates.for('elements.table.machines.name')}</div> */}
      <div className='hcol'></div>
      <div className='hcol'></div>
      <div className='hcol'></div>
      <div className='hcol'></div>
      <div className='hcol'></div>
    </>,
    row: (row) => <>
      {isDesktopScreen() && <div className='col'>{formatDate(new Date(row.createdAt))}</div>}
      {isDesktopScreen() && <div className='col'>{row.imei}</div>}
      {/* <div className='col'>{row.name}</div> */}
      <div className='col icocol' onClick={() => navigate(`/communal/machine/${row.id}`)}>
        <i className='svgfont-link' />
      </div>
      <div className='col icocol' onClick={() => openModal((props) => CardHistoryBody({ ...props, machineId: row.id, services, session }))}>
        <i className='svgfont-user-card' />
      </div>
      <div className='col icocol' onClick={() => openModal((props) => MachinePopupQRCodeBody({ ...props, machineId: row.id, services, session, translates: session.translates }))}>
        <i className='svgfont-qrcode' />
      </div>
      <div className='col icocol' onClick={() => row.machineTypeId && openModal((props) => MachinePopupDocBody({ ...props, machineTypeId: row.machineTypeId, services, session, translates: session.translates }))} >
        {row.machineTypeId ? <i className='svgfont-documentation' /> : '-'}
      </div>
      {/* <div className='col icocol' onClick={() => openModal((props) => RelatedUsersPage({...props, machineId: row.id, services, session}))}>
        <i className='svgfont-user' />
      </div> */}
      <div className='col icocol' onClick={() => openModal((props) => ServicemanMachineMapPopup({ ...props, imei: row.imei, services, session }))}>
        <i className='svgfont-map' />
      </div>
    </>,
    translates: session.translates
  }

  return <LoggedInPageLayout pageName='serviceman-machines' services={services} session={session}
    navbarLeft={<BackButton services={services} translates={session.translates} />}>
    <SearchTable ref={searchTableRef} {...tableParams} />
    {/* <ServicemanEditMachinesPopup id={edited} onClose={() => setEdited(undefined)} services={services} session={session} />
    <RelatedUsersPage machineId={editUsers} onClose={() => setEditUsers(undefined)} services={services} session={session} />
    <ServicemanInsertMachinesPopup isOpen={inserted} onClose={() => setInserted(false)} services={services} session={session} /> */}

    {/* <Modal isOpen={docsType !== undefined} onClose={() => { setDocType(undefined) }} >
      <MachinePopupDocBody machineTypeId={docsType} services={services} session={session} translates={session.translates} />
    </Modal>
    <Modal isOpen={qrPopup !== undefined} onClose={() => { setQRPopup(undefined) }} >
      <MachinePopupQRCodeBody machineId={qrPopup} services={services} session={session} translates={session.translates} />
    </Modal> */}
  </LoggedInPageLayout>
}
